import { render } from "./TechnologyStacks.vue?vue&type=template&id=7b620cc4&scoped=true&ts=true"
import script from "./TechnologyStacks.vue?vue&type=script&lang=ts"
export * from "./TechnologyStacks.vue?vue&type=script&lang=ts"

import "./TechnologyStacks.vue?vue&type=style&index=0&id=7b620cc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b620cc4"]])

export default __exports__